import { FC, PropsWithChildren } from 'react';
import { Box } from '../../../ui/layout/Box';
import { useIsMobile } from '../../../utils/getIsMobile';

/** Отступы и фон сетки профиля: у пользовательского и роботного вариантов они обязаны совпадать */
export const BusinessGridBox: FC<PropsWithChildren> = ({ children }) => {
    const isWideProfile = !useIsMobile();

    return (
        <Box
            p={isWideProfile ? 0 : 2}
            pr={isWideProfile ? 1 : 2}
            background={isWideProfile ? 'none' : 'var(--background-primary)'}
        >
            {children}
        </Box>
    );
};
